import React, { useRef, useEffect, useState } from 'react';
import FacetList from '../../../components/react/facet/FacetList';
import LoadMore from '../../../components/react/LoadMore';
import Dropdown from '../../../components/react/Dropdown';
import SearchBar from './components/SearchBar';
import SearchResultCard from './components/SearchResultCard';
import createScrollShapes from '../../../helpers/createScrollShapes';
import { useParams, useFetch } from './hooks/index.ts';
const SearchResultsListing = ({ endpoint, heading, placeholder, searchSummaryLabel, searchLabel, clearLabel, filterResultsLabel, useQuery, initialQuery, inputLabel, resourcesUrl }) => {
    const [queryParams, setQuery, setPage, setSort, setFilters, setTag] = useParams();
    const { q, page, sort, filters, tag } = queryParams;
    const [displayedResults, setDisplayedResults] = useState([]);
    const { results, loading } = useFetch(endpoint, Boolean(useQuery), {
        q,
        page,
        sort,
        filters,
        tag
    });
    const { facets, resultListing, resultsInfo, totalResults, resultsPerPage, sortOptions } = results;
    const simpleMastheadContainer = useRef(null);
    const listingContainer = useRef(null);
    const handleReset = () => {
        setFilters({});
    };
    const handleLoadMore = (p) => {
        setPage(p);
    };
    const scrollIntoViewWithOffset = ({ selector, offset }) => {
        window.scrollTo({
            behavior: 'smooth',
            top: selector?.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                offset
        });
    };
    useEffect(() => {
        if (initialQuery)
            setQuery(initialQuery);
        if (simpleMastheadContainer?.current)
            createScrollShapes({
                containerEl: simpleMastheadContainer.current,
                count: 3,
                prefix: 'simple-masthead__',
                scrollAnimate: false
            });
    }, []);
    useEffect(() => {
        if (resultListing)
            setDisplayedResults([...displayedResults, ...resultListing]);
    }, [resultListing]);
    const handleFilters = (filter) => {
        const selectedFacets = { ...filters };
        selectedFacets[filter.name] = filter.options;
        setDisplayedResults([]);
        setFilters(selectedFacets);
        scrollIntoViewWithOffset({ selector: listingContainer.current, offset: 150 });
    };
    const handleQuery = (query) => {
        if (q !== query && query !== '')
            setDisplayedResults([]);
        setQuery(query);
    };
    const handleTag = (t) => {
        setDisplayedResults([]);
        setTag([t]);
        scrollIntoViewWithOffset({ selector: listingContainer.current, offset: 150 });
    };
    const handleSort = (s) => {
        if (sort !== s)
            setDisplayedResults([]);
        setSort(s);
    };
    return (React.createElement("div", { className: "search-results-listing", ref: listingContainer },
        useQuery && (React.createElement("div", { className: "search-results-listing__header" },
            React.createElement("div", { className: "simple-masthead" },
                React.createElement("div", { className: "container", ref: simpleMastheadContainer },
                    React.createElement("h1", { className: "simple-masthead__heading" }, heading),
                    React.createElement("p", { className: "simple-masthead__subheading" }, !!q && q.length && (React.createElement(React.Fragment, null,
                        searchSummaryLabel,
                        " ",
                        React.createElement("span", null, q)))))),
            React.createElement("div", { className: "search-bar" },
                React.createElement("div", { className: "container" },
                    React.createElement(SearchBar, { placeholder: placeholder, searchLabel: searchLabel, clearLabel: clearLabel, onSearch: handleQuery, initialQuery: q && q, inputLabel: inputLabel }))))),
        React.createElement("div", { className: "container container--with-sidebar search-results-listing__facets-and-results" },
            displayedResults.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "container__aside" },
                    React.createElement("div", { className: "search-results-listing__results-info-mobile" }, resultsInfo),
                    React.createElement(FacetList, { facets: facets, selectedFacets: filters, onFiltersChange: handleFilters, filterResultsLabel: filterResultsLabel, loading: loading })),
                React.createElement("div", { className: "container__content" },
                    React.createElement("div", { className: "facet-cards-list" },
                        React.createElement("div", { className: "facet-cards-list__inner" },
                            React.createElement("div", { className: "search-results-listing__info-and-sort" },
                                React.createElement("div", { className: "search-results-listing__results-info" }, resultsInfo),
                                React.createElement("div", { className: "search-results-listing__sort FormSelection" }, sortOptions && (React.createElement(Dropdown, { options: sortOptions, innerLabel: "Sort by", selectedOption: sort
                                        ? sortOptions.find((opt) => {
                                            if (opt.value === sort) {
                                                return opt.value;
                                            }
                                            return null;
                                        })
                                        : sortOptions.find((opt) => opt.selected === true), onChange: (s) => handleSort(s.value) })))),
                            React.createElement("div", { className: "facet-cards-list__container" }, displayedResults.map((result, i) => (React.createElement(SearchResultCard, { key: i, searchItem: result, resourcesUrl: resourcesUrl, onTagClick: (t) => handleTag(t) })))),
                            loading && page > 1 && React.createElement("div", { className: "loading" }),
                            !!page && !loading && (React.createElement(LoadMore, { currentPage: Number(page), totalPages: Math.ceil(totalResults / resultsPerPage), onNavigate: (p) => handleLoadMore(p), resultsPerPage: resultsPerPage }))))))),
            resultListing?.length === 0 && !loading && (React.createElement("p", { className: "search-results-listing__no-results" }, resultsInfo)),
            displayedResults.length === 0 && loading && (React.createElement("div", { className: "loading loading--centered" })))));
};
export default React.memo(SearchResultsListing);
